// import { DatePicker } from 'antd';
import React, { useState, useEffect } from "react";
import Select from "react-select";
import Axios from "axios";
import {
  API_BASE_URL,
  GET_VSTORE_PROD,
  GET_TAXES_DATA,
  INSERT_PURCHASE_ORDEDR,
  DOWNLD_EXCEL,
  PO_UPLOAD_EXCEL,
  GET_STORE,
} from "../../../Config";
import Swal from "sweetalert2";
import SpinLoader from "../../../feature-module/loader/SpinLoader";

const AddPOnew = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [storesData, setStoresData] = useState([]);
  const [mainStoreId, setMainStoreId] = useState(0);
  const [mainStoreName, setMainStoreName] = useState("");
  const [selectedStore, setSelectedStore] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [uploadExcelLoading, setUploadExcelLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedDiscountType, setSelectedDiscountType] = useState(null);
  const [isDisplayProduct, setIsDisplayProduct] = useState(true);
  const [isDisplayExcel, setIsDisplayExcel] = useState(false);
  const [isDisplayProductBtn, setIsDisplayProductBtn] = useState(true);
  const [isDisplayExcelBtn, setIsDisplayExcelBtn] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [categoryData, setCategoryData] = useState([]);
  const [unitsData, setUnitsData] = useState([]);
  const [suppliersData, setSuppliersData] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [taxesData, setTaxesData] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [poDate, setPoDate] = useState("");
  const [expectedDate, setExpectedDate] = useState("");
  const [enterNotes, setEnterNotes] = useState(null);
  const [inputValues, setInputValues] = useState({});
  const [selectedTaxes, setSelectedTaxes] = useState({});
  // const [amounts, setAmounts] = useState({});
  const [totalAmount, setTotalAmount] = useState("");
  // const [estimateAmount, setEstimateAmount] = useState(null);
  const [enteredDiscount, setEnteredDiscount] = useState(null);
  const [selectedProductOption, setSelectedProductOption] = useState(null);
  const [loading, setLoading] = useState(false);
  console.log(mainStoreName, "Mainstore");
  // #region Session userdetails
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    const supplierData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_Supplier")
    );
    const categoryData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_CATEGORY")
    );
    const unitsData = JSON.parse(
      sessionStorage.getItem("filteredDDLData_UNITS")
    );
    // const storesData = JSON.parse(sessionStorage.getItem('filteredDDLData_Stores'));

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      setCategoryData(categoryData);
      setSuppliersData(supplierData);
      setUnitsData(unitsData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (userDataSession.OrgId && mainStoreId) {
      const fetchData = () => {
        console.log("fecthing..");
        const requestData = {
          OrgId: userDataSession.OrgId,
          CategoryId: 0,
          BarCode: 0,
          ProductId: 0,
          StoreId: mainStoreId,
          IsForSale: 1,
          UserId: userDataSession.UserId,
          Type: 1,
        };

        console.log(requestData, "storeprod data api sending");
        setLoading(true);
        Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
          .then((response) => {
            // Handle the response data as needed
            setProductsData(response.data.ResultData);
            console.log("Data fetched successfully:", response.data);
            setLoading(false);
          })
          .catch((error) => {
            setProductsData([]);
            console.error("Error fetching data:", error);
            setLoading(false);
          });
      };

      if (selectedCategory) {
        fetchData();
      }
    }
  }, [userDataSession, mainStoreId]);

  useEffect(() => {
    const fetchData = () => {
      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: selectedCategory.value,
        BarCode: 0,
        ProductId: 0,
        StoreId: mainStoreId,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 1,
      };

      console.log(requestData, "storeprod data api sending");
      setLoading(true);
      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          // Handle the response data as needed
          setProductsData(response.data.ResultData);
          console.log("Data fetched successfully:", response.data);
          setLoading(false);
        })
        .catch((error) => {
          setProductsData([]);
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    };

    if (selectedCategory) {
      fetchData();
    }
  }, [selectedCategory, userDataSession.OrgId, mainStoreId]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_TAXES_DATA}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            setTaxesData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(`${API_BASE_URL}${GET_STORE}?OrgId=${userDataSession.OrgId}`)
        .then((response) => {
          if (response.data.Status) {
            const fetchedStoresData = response.data.ResultData;
            setStoresData(fetchedStoresData);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  const handleSupplierChange = (selectedOption) => {
    setSelectedSupplier(selectedOption);
  };

  const handleDateChange = (e) => {
    setPoDate(e.target.value);
  };

  const handleExpectedDateChange = (e) => {
    setExpectedDate(e.target.value);
  };

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
  };

  const handleStoreChange = (selectedOption) => {
    setSelectedStore(selectedOption);
    if (selectedOption) {
      setMainStoreId(selectedOption.value);
      setMainStoreName(selectedOption.label);
    } else {
      // Reset to default if cleared (optional, depending on requirements)
      setMainStoreId(0);
      setMainStoreName("");
    }
  };

  const handleAddProduct = (selectedOption) => {
    setErrorMessage(`Excel upload is disabled because products have already been selected.<br/>
      Please clear the selected products to enable Excel upload.`);

    //  setSelectedProduct(value);
    setIsDisplayExcel(true);
    setIsDisplayExcelBtn(false);
    setIsDisplayProductBtn(true);

    const selectedProduct = productsData.find(
      (prod) => prod.Id === selectedOption.value
    );

    if (selectedProduct) {
      const productExists = selectedProducts.find(
        (prod) => prod.Id === selectedProduct.Id
      );

      if (productExists) {
        alert("Product already added to the list.");
      } else {
        const newIndex = selectedProducts.length;
        const newProduct = {
          ...selectedProduct,
          Quantity: 0,
          Comments: "",
          UnitPrice: selectedProduct.StorePrice || "",
          Units: "",
          Tax: "",
        };
        setSelectedProducts([...selectedProducts, newProduct]);
        setInputValues((prev) => ({
          ...prev,
          [newIndex]: {
            Quantity: "0",
            UnitPrice: selectedProduct.StorePrice || "",
          },
        }));
      }
    }
    setSelectedProductOption(null);
  };

  const handleInputChange = (index, field, value) => {
    const updatedInputValues = {
      ...inputValues,
      [index]: {
        ...inputValues[index],
        [field]: value,
      },
    };

    setInputValues(updatedInputValues);
    // setAmounts({
    //     ...amounts,
    //     [index]: calculateAmount(index, updatedInputValues)
    // });
  };

  const handleUnitChange = (index, value) => {
    setInputValues({
      ...inputValues,
      [index]: {
        ...inputValues[index],
        Units: value,
      },
    });
  };

  const handleTaxChange = (index, selectElement) => {
    const selectedValue = selectElement.value;

    // If the "Choose" option is selected, reset the tax rates for that row
    if (selectedValue === "choose") {
      setSelectedTaxes((prevState) => ({
        ...prevState,
        [index]: {
          Id: null,
          TaxRate: 0,
          SGSTRate: 0,
          CGSTRate: 0,
          IGSTRate: 0,
        },
      }));
    } else {
      try {
        // Parse the selected tax details only if it's not "Choose"
        const selectedOption = JSON.parse(selectedValue);
        const { Id, TaxRate, SGSTRate, CGSTRate, IGSTRate } = selectedOption;

        // Update the selected taxes
        setSelectedTaxes((prevState) => ({
          ...prevState,
          [index]: {
            Id,
            TaxRate,
            SGSTRate,
            CGSTRate,
            IGSTRate,
          },
        }));

        // Trigger calculation only when quantity and unit price are available
        const quantity = inputValues[index]?.Quantity;
        const unitPrice = inputValues[index]?.UnitPrice;

        if (quantity && unitPrice) {
          const updatedAmount = calculateAmount(
            quantity,
            unitPrice,
            CGSTRate,
            SGSTRate
          );
          // Optionally store or update the amount
          console.log("Calculated Amount:", updatedAmount);
        }
      } catch (error) {
        console.error("Error parsing selected value:", error);
      }
    }
  };

  const calculateAmount = (
    quantity,
    unitPrice,
    CGSTRate = 0,
    SGSTRate = 0
    // IGSTRate = 0
  ) => {
    const parsedQuantity = parseFloat(quantity) || 0;
    const parsedUnitPrice = parseFloat(unitPrice) || 0;

    const baseAmount = parsedQuantity * parsedUnitPrice;

    // Calculate tax if tax rates are selected
    let totalTaxRate = 0;
    if (CGSTRate || SGSTRate) {
      totalTaxRate = (CGSTRate + SGSTRate) / 100;
    }

    const taxAmount = baseAmount * totalTaxRate;

    return baseAmount + taxAmount;
  };

  const getTotalAmount = () => {
    return selectedProducts.reduce((total, item, index) => {
      const quantity = inputValues[index]?.Quantity || 0;
      const unitPrice = inputValues[index]?.UnitPrice || 0;
      const CGSTRate = selectedTaxes[index]?.CGSTRate || 0;
      const SGSTRate = selectedTaxes[index]?.SGSTRate || 0;

      const amount = calculateAmount(quantity, unitPrice, CGSTRate, SGSTRate);
      return total + amount;
    }, 0);
  };

  useEffect(() => {
    setTotalAmount(getTotalAmount().toFixed(2));
  }, [selectedProducts, inputValues, selectedTaxes]);

  // Calculate the final total amount with the discount
  const calculateTotalWithDiscount = () => {
    let calculatedTotalAmount = getTotalAmount();
    let discountAmount = 0;

    if (selectedDiscountType === "1") {
      // Fixed discount
      discountAmount = parseFloat(enteredDiscount) || 0;
    } else if (selectedDiscountType === "2") {
      // Percentage discount
      const discountPercentage = parseFloat(enteredDiscount) || 0;
      discountAmount = (discountPercentage / 100) * calculatedTotalAmount;
    }

    return Math.max(0, calculatedTotalAmount - discountAmount); // Ensure total doesn't go below 0
  };

  // Update total amount when products, input values, or selected taxes change
  useEffect(() => {
    setTotalAmount(calculateTotalWithDiscount().toFixed(2));
  }, [
    selectedProducts,
    inputValues,
    selectedTaxes,
    enteredDiscount,
    selectedDiscountType,
  ]);

  const handleDelete = (index) => {
    setSelectedProducts((prevData) => prevData.filter((_, i) => i !== index));
  };

  const calculateTaxAmount = () => {
    return selectedProducts.reduce((totalTax, prod, index) => {
      const quantity = inputValues[index]?.Quantity || prod.Quantity || 0;
      const unitPrice = inputValues[index]?.UnitPrice || prod.UnitPrice || 0;
      const CGSTRate = selectedTaxes[index]?.CGSTRate || prod.CGSTRate || 0;
      const SGSTRate = selectedTaxes[index]?.SGSTRate || prod.SGSTRate || 0;

      const baseAmount = quantity * unitPrice;
      const taxRate = (CGSTRate + SGSTRate) / 100;

      return totalTax + baseAmount * taxRate;
    }, 0);
  };

  // Calculate discount based on type
  const calculateDiscount = () => {
    if (selectedDiscountType === "2") {
      // Percentage Discount
      const discountPercentage = parseFloat(enteredDiscount) || 0;
      return {
        DiscountPercent: discountPercentage,
        DiscountAmount: (discountPercentage / 100) * totalAmount,
      };
    } else {
      // Fixed Discount
      return {
        DiscountPercent: 0,
        DiscountAmount: parseFloat(enteredDiscount) || 0,
      };
    }
  };

  // const { DiscountAmount, DiscountPercent } = calculateDiscount();
  const { DiscountAmount } = calculateDiscount();
  const taxAmount = calculateTaxAmount();

  // region Add PO
  const handleSubmit = (status, event) => {
    if (event) event.preventDefault();

    if (!selectedStore) {
      alert("Please select a store.");
      return;
    }

    console.log(selectedProducts, "selected products");

    const requestPayload = {
      orgid: userDataSession.OrgId,
      userid: userDataSession.UserId,
      MainStoreId: mainStoreId,
      SupplierId: selectedSupplier?.value || "0",
      PurchaseOrder: {
        Id: 0,
        StoreId: mainStoreId,
        SupplierId: selectedSupplier ? selectedSupplier.value : "0",
        Notes: enterNotes,
        PODate: poDate,
        ExpectedDate: expectedDate,
        POStatus: status,
        // InvoiceAmount: totalAmount,
        EstimateAmount: totalAmount,
        DiscountAmount: DiscountAmount,
        DiscountType: selectedDiscountType,
        DiscountPercent: enteredDiscount,
        TaxAmount: taxAmount.toFixed(2),
      },
      productdetails: selectedProducts.map((prod, index) => ({
        detailid: 0,
        ProductId: prod.Id,
        Quantity: inputValues[index]?.Quantity || prod.Quantity,
        UOM: inputValues[index]?.Units || null,
        UnitPrice: inputValues[index]?.UnitPrice || prod.UnitPrice,
        CGSTRate: selectedTaxes[index]?.CGSTRate || prod.CGSTRate || null,
        SGSTRate: selectedTaxes[index]?.SGSTRate || prod.SGSTRate || null,
        IGSTRate: selectedTaxes[index]?.IGSTRate || prod.IGSTRate || null,
        postatus: "DRAFT",
        TaxId: String(selectedTaxes[index]?.Id) || null,
      })),
    };

    console.log(requestPayload, "data sending to service...");

    setSubmitLoading(true);

    Axios.post(`${API_BASE_URL}${INSERT_PURCHASE_ORDEDR}`, requestPayload)
      .then((response) => {
        const data = response.data;
        setSubmitLoading(false);
        if (data[0].Success == 1) {
          Swal.fire({
            title: "Success",
            text: "Purchase order added successfully.",
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload(); // Reload the page after the user confirms the Swal alert
            }
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to added purchase order.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setSubmitLoading(false);
        Swal.fire({
          title: "Error",
          text: "An error occurred while adding the purchase order.",
          icon: "error",
        });
        console.error("Error:", error);
      });
  };

  // #region downlaod excel
  const handleAddDownloadExcel = (e) => {
    e.preventDefault();
    if (mainStoreId) {
      const link = document.createElement("a");
      link.href = `${API_BASE_URL}${DOWNLD_EXCEL}?StoreId=${mainStoreId}&OrgId=${userDataSession.OrgId}`;

      link.download = "Products.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert("Please select a store first.");
    }
  };

  // Handle file selection
  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (
  //     file &&
  //     (file.type ===
  //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
  //       file.type === "application/vnd.ms-excel")
  //   ) {
  //     setSelectedFile(file);
  //   } else {
  //     alert("Please select a valid Excel file.");
  //   }
  // };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (
      file &&
      (file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel")
    ) {
      setSelectedFile(file);
      setIsDisplayProduct(false); // Disable product selection
      setIsDisplayProductBtn(false); // Hide submit buttons
      setIsDisplayExcelBtn(true);
      setIsDisplayExcel(true); // Ensure Excel input remains enabled
      setErrorMessage(`Product selection is disabled because an Excel file has been uploaded.<br/>
        Please clear the uploaded file to enable product selection.`);
    } else {
      alert("Please select a valid Excel file.");
    }
  };

  // #region Handle file upload
  const handleUploadExcel = async (e) => {
    e.preventDefault();

    if (!selectedStore) {
      alert("Please select a store.");
      return;
    }

    setIsDisplayProduct(false);
    setIsDisplayProductBtn(false);
    setIsDisplayExcelBtn(true);
    setErrorMessage(`Product selection is disabled because an Excel file has already been uploaded.
      <br/> Please clear the uploaded file to enable product selection.`);

    if (!selectedFile) {
      alert("Please select a file first.");
      return;
    }

    setUploadExcelLoading(true);

    const formData = new FormData();
    formData.append("orgid", userDataSession.OrgId);
    formData.append("userid", userDataSession.UserId);
    formData.append("MainStoreId", mainStoreId);
    formData.append("SupplierId", selectedSupplier.value);
    formData.append("PODate", poDate);
    formData.append("ExpectedDate", expectedDate);
    formData.append("Notes", enterNotes);
    formData.append("DiscountAmount", DiscountAmount);
    formData.append("DiscountType", selectedDiscountType);
    formData.append("StoreId", mainStoreId);
    formData.append("POStatus", "DRAFT");
    formData.append("Status", "COMPLETED");
    formData.append("file", selectedFile);
    // formData.append("EstimateAmount", `${estimateAmount}`);
    // formData.append('postatus', 'COMPLETED');

    try {
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const response = await fetch(`${API_BASE_URL}${PO_UPLOAD_EXCEL}`, {
        method: "POST",
        body: formData,
      });

      console.log("Fetch response received:", response);

      if (response.ok) {
        const data = await response.json();
        alert("File uploaded successfully");
        setUploadExcelLoading(false);
        window.location.reload();
        console.log(data);
      } else {
        setUploadExcelLoading(false);
        alert("File upload failed");
        console.error("Upload failed", response.statusText);
      }
    } catch (error) {
      setUploadExcelLoading(false);
      console.error("Error uploading file", error);
      alert("Error uploading file");
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "2.4rem", // Ensure control is tall enough
      height: "2.4rem",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "2.4rem", // Match the height of the control
      padding: "0 6px",
      display: "flex",
      alignItems: "center", // Center content vertically
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
    }),
    placeholder: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center", // Center the placeholder vertically
    }),
  };

  const handleClose = () => {
    setExpectedDate("");
    setPoDate("");
    setSelectedCategory(null);
    setSelectedProducts([]);
    setEnteredDiscount("");
    setProductsData([]);
    setSelectedSupplier(null);
    setSelectedProductOption(null);

    setSelectedFile(null);
    setIsDisplayExcelBtn(false);
    setIsDisplayProductBtn(true);
    setIsDisplayProduct(true); // Enable product dropdown
    setIsDisplayExcel(false); // Enable Excel upload
    setErrorMessage("");

    // Reset file input
    document.getElementById("excelInput").value = "";
  };

  return (
    <div>
      {/* Add Purchase */}
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasPOAdd {
            width: 95% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasPOAdd {
            width: 70% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasPOAdd {
            width: 70% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #offcanvasPOAdd {
            width: 50% !important;
          }
        }
        `}
      </style>

      {submitLoading && <SpinLoader />}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasPOAdd"
        aria-labelledby="offcanvasRightLabel"
        // style={{ minWidth: "64%", maxWidth: "64%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Add Purchase Order</h4>
          {/* <p className="text-danger fw-semibold">{excelErrorMess}</p> */}
          <div className="d-flex ms-auto align-items-center">
            <div className="d-flex justify-content-end align-items-center">
              <p className="mb-0">Download Template</p>
              <button
                className="btn d-flex"
                title="Download template"
                onClick={handleAddDownloadExcel}
              >
                <i className="fa-solid fa-download text-danger fs-4"></i>
              </button>
            </div>
            <button
              type="button"
              className="btn-close text-reset ms-2"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={handleClose}
            />
          </div>
        </div>
        <hr />
        <div
          className={`alert alert-warning ${
            errorMessage.length > 1 ? "d-block" : "d-none"
          }`}
          dangerouslySetInnerHTML={{ __html: errorMessage }}
        ></div>
        <div className="offcanvas-body">
          <form>
            <div className="row">
              <div className="col-lg-3 col-md-3 form-group">
                <label className="form-label">
                  Supplier<span className="fw-bold text-danger">*</span>
                </label>
                <Select
                  className="select"
                  id="supplierSelect"
                  value={selectedSupplier}
                  onChange={handleSupplierChange}
                  options={suppliersData?.map((supp) => ({
                    value: supp.ItemId,
                    label: supp.ItemValue,
                  }))}
                  placeholder="Choose supplier"
                  styles={customStyles}
                />
              </div>

              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="input-blocks">
                  <label>
                    Date<span className="fw-bold text-danger">*</span>
                  </label>
                  <div className="input-groupicon calender-input">
                    <input
                      type="date"
                      className="form-control"
                      onChange={handleDateChange}
                      value={poDate}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12">
                <div className="input-blocks">
                  <label>
                    Expected Date<span className="fw-bold text-danger">*</span>
                  </label>
                  <div className="input-groupicon calender-input">
                    <input
                      type="date"
                      className="form-control"
                      onChange={handleExpectedDateChange}
                      value={expectedDate}
                    />
                  </div>
                </div>
              </div>
              <div className=" col-lg-3 col-md-3 form-group">
                <label className="form-label">Store</label>
                <span className="fw-bold text-danger">*</span>
                <Select
                  className="select"
                  id="Select Store"
                  value={selectedStore}
                  onChange={handleStoreChange}
                  options={storesData?.map((store) => ({
                    value: store.Id,
                    label: store.Name,
                  }))}
                  placeholder="Choose Store"
                  styles={customStyles}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-3">
                <label className="form-label">
                  Category<span className="fw-bold text-danger">*</span>
                </label>
                <Select
                  className="select"
                  id="categorySelect"
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  options={categoryData?.map((store) => ({
                    value: store.ItemId,
                    label: store.ItemValue,
                  }))}
                  placeholder="Choose Category"
                  styles={customStyles}
                />
              </div>
              <div className="col-lg-3 col-md-3">
                <label className="form-label">Products</label>
                <Select
                  className="select"
                  value={selectedProductOption}
                  options={productsData?.map((prod) => ({
                    value: prod.Id,
                    label: prod.ProductName,
                  }))}
                  onChange={handleAddProduct}
                  placeholder={loading ? "Loading..." : "Search products..."}
                  styles={customStyles}
                  isDisabled={!isDisplayProduct}
                  isLoading={loading}
                />
              </div>

              <div className=" col-lg-3 col-md-3form-group">
                <label className="form-label">Discount Type</label>
                <select
                  className="form-select"
                  onChange={(e) => setSelectedDiscountType(e.target.value)}
                >
                  <option>Choose type</option>
                  <option value="1">Fixed</option>
                  <option value="2">Percentage</option>
                </select>
              </div>
              <div className=" col-lg-3 col-md-3form-group">
                <label className="form-label">Discount</label>
                <input
                  type="float"
                  className="form-control"
                  placeholder="Enter discount"
                  value={enteredDiscount}
                  onChange={(e) => setEnteredDiscount(e.target.value)}
                />
              </div>
              <div className="col-lg-12 col-md-12 d-flex my-3">
                <div className=" align-items-center">
                  <label className="form-label">Upload Through Excel</label>
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    id="excelInput"
                    className="form-control me-2"
                    style={{ width: "15rem" }}
                    disabled={isDisplayExcel}
                    onChange={handleFileChange}
                  />
                  {/* <button className={`btn btn-primary me-2 ${isDisplayExcelBtn ? 'd-block' : 'd-none'}`}
                   onClick={handleUploadExcel}
                  >
                    {uploadExcelLoading ? "Uploading..." : "Upload Excel"}
                  </button> */}
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-lg-12">
                <div className="modal-body-table">
                  <div
                    className="table-responsive"
                    style={{ maxHeight: "20rem", overflowY: "auto" }}
                  >
                    <table className="table  datanew">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product</th>
                          <th>InStock</th>
                          <th>Quantity</th>
                          <th>Price</th>
                          <th>Units</th>
                          <th>Tax</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedProducts.length !== 0 ? (
                          selectedProducts.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td title={item.ProductName}>
                                {item.ProductName.length > 15
                                  ? `${item.ProductName.substring(0, 15)}...`
                                  : item.ProductName}
                              </td>
                              <td>{item?.InStock}</td>
                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="Quantity"
                                  value={inputValues[index]?.Quantity || ""}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "Quantity",
                                      e.target.value
                                    )
                                  }
                                  style={{ width: "90px" }}
                                  onWheel={(e) => e.target.blur(e)}
                                  required
                                />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  style={{ width: "5rem" }}
                                  value={inputValues[index]?.UnitPrice || ""}
                                  className="form-control"
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "UnitPrice",
                                      e.target.value
                                    )
                                  }
                                  onWheel={(e) => e.target.blur(e)}
                                />
                              </td>
                              <td>
                                <select
                                  className="form-select"
                                  value={
                                    inputValues[index]?.Units || item.Units
                                  }
                                  onChange={(e) =>
                                    handleUnitChange(index, e.target.value)
                                  }
                                >
                                  <option>Choose</option>
                                  {unitsData.map((item, index) => (
                                    <option key={index} value={item.ItemId}>
                                      {item.ItemValue}
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td>
                                <select
                                  className="form-select"
                                  onChange={(e) =>
                                    handleTaxChange(index, e.target)
                                  }
                                >
                                  <option value="choose">Choose</option>
                                  {taxesData?.map((tax) => (
                                    <option
                                      key={tax.Id}
                                      value={JSON.stringify({
                                        Id: tax.Id,
                                        TaxRate: tax.TaxRate,
                                        SGSTRate: tax.SGSTRate,
                                        CGSTRate: tax.CGSTRate,
                                        IGSTRate: tax.IGSTRate,
                                      })}
                                    >
                                      {tax.TaxRate}%
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td>
                                {selectedTaxes[index]?.CGSTRate ||
                                selectedTaxes[index]?.SGSTRate
                                  ? parseFloat(
                                      calculateAmount(
                                        inputValues[index]?.Quantity,
                                        inputValues[index]?.UnitPrice,
                                        selectedTaxes[index]?.CGSTRate,
                                        selectedTaxes[index]?.SGSTRate
                                      )
                                    ).toFixed(2)
                                  : (
                                      inputValues[index]?.Quantity *
                                      inputValues[index]?.UnitPrice
                                    ).toFixed(2)}
                              </td>
                              <td>
                                <button
                                  className="btn border text-danger"
                                  onClick={() => handleDelete(index)}
                                >
                                  <i className="feather-trash-2 fs-6"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="12" className="text-center">
                              No Data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <table className="table">
                    <tfoot>
                      <tr>
                        <td colSpan="1" className="text-end fw-bold fs-6">
                          Total Discount:
                        </td>
                        <td className="fw-bold text-primary fs-5">
                          {Number(DiscountAmount || 0).toFixed(2)}
                        </td>
                        <td colSpan="2" className="text-end fw-bold fs-6">
                          Total Tax:
                        </td>
                        <td className="fw-bold text-primary fs-5">
                          {Number(taxAmount || 0).toFixed(2)}
                        </td>
                        <td colSpan="2" className="text-end fw-bold fs-6">
                          Total Amount:
                        </td>
                        <td className="fw-bold text-primary fs-5">
                          {totalAmount}
                        </td>
                        {/* <td>{totalAmount}</td> */}
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="input-blocks">
                    <label>Shipment Details</label>
                    <textarea
                      placeholder="Enter notes"
                      onChange={(e) => {
                        setEnterNotes(e.target.value);
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-auto d-flex justify-content-end p-3">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={handleClose}
                disabled={submitLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger me-2"
                onClick={handleClose}
              >
                Clear
              </button>
              <button
                type="button"
                className={`btn btn-info me-2 ${
                  isDisplayProductBtn ? "d-block" : "d-none"
                }`}
                onClick={() => handleSubmit("DRAFT")}
                // disabled={submitLoading}
              >
                {submitLoading ? "Submitting.." : "Save As Draft"}
              </button>
              <button
                type="button"
                className={`btn btn-primary me-2 ${
                  isDisplayProductBtn ? "d-block" : "d-none"
                }`}
                onClick={() => handleSubmit("PENDINGAPPROVAL")}
                // disabled={submitLoading}
              >
                {submitLoading ? "Submitting.." : "Submit for Approval"}
              </button>
              <button
                className={`btn btn-success me-2 ${
                  isDisplayExcelBtn ? "d-block" : "d-none"
                }`}
                onClick={handleUploadExcel}
                disabled={uploadExcelLoading}
              >
                {uploadExcelLoading ? "Uploading..." : "Upload Excel"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddPOnew;
